import { useState } from "react"
import axios from "axios"
import _ from "lodash"

const useSuggestedKeywords = () => {
  const [keywords, setKeywords] = useState([])
  const [suggestedKeywords, setSuggestedKeywords] = useState([])
  // Resolve a tag to its keyword record. Tags typed by hand are flagged as new,
  // but the term may already exist (the server rejects duplicates with a 400),
  // so fall back to looking it up instead of failing the whole batch.
  const resolveKeyword = async tag => {
    const term = tag.isNewKey
      ? tag.value
      : tag.source && tag.source.term
        ? tag.source.term
        : tag.value

    if (tag.isNewKey) {
      try {
        return await axios.post("keywords/", {
          seedId: `keyword_${term}`,
          term: term,
        })
      } catch (error) {
        console.log("createKeyword failed, looking up existing term:", term)
      }
    }

    try {
      return await axios.get("keywords/findByTerm/" + term)
    } catch (error) {
      console.log("findByTerm failed for term:", term, error)
      return null
    }
  }

  const updateKeywords = async newKeywords => {
    const safeNewKeywords = newKeywords || []
    const sortedNew = _.sortBy(
      [..._.uniqBy([...safeNewKeywords], "value")],
      ["value"]
    )
    // handles search field change
    if (
      (keywords || []).length !== sortedNew.length ||
      sortedNew.some(
        v => (keywords || []).find(v2 => v.value === v2.value) === undefined
      )
    ) {
      console.log("updateKeywords: ", sortedNew)
      const newKeywordObjs = await Promise.all(sortedNew.map(resolveKeyword))
      console.log("newKeywordObjs: ", newKeywordObjs)
      const children = await Promise.all(
        newKeywordObjs
          .filter(
            k => {
              const kw = k && k.data && k.data.data
              return kw && kw.children && kw.children.length > 0;
            }
          )
          .map(k => {
            return axios.get("keywords/findByTerms/" + k.data.data.children);
          })
      )
      const newSuggested = children
        .map(c => c.data.data)
        .reduce((acc, val) => acc.concat(val), [])

      console.log("newSuggested: ", newSuggested)
      setSuggestedKeywords(
        newSuggested.filter(
          s =>
            sortedNew.find(
              k => k.value.toLowerCase() === s.term.toLowerCase()
            ) === undefined
        )
      )
      setKeywords(sortedNew)
    }
  }
  return [suggestedKeywords, updateKeywords]
}

export default useSuggestedKeywords
